<div class="contact__card" *ngIf="type === 'contact'">
  <hdi-icon
    [disabled]="disabled"
    [iconName]="icon"
    [iconPrefix]="'far'"
    [color]="iconColor"
    [size]="Sizes.LARGE"
    *ngIf="icon"
  ></hdi-icon>
  <div class="content">
    <strong [innerHTML]="title"></strong>
    <ng-container *ngIf="subtitle && !isEmail(subtitle); else email">
      <span *ngIf="subtitle" [innerHTML]="subtitle"></span>
    </ng-container>
    <ng-template #email>
      <hdi-link
        *ngIf="subtitle"
        [type]="LinkType.NOSTYLES"
        [href]="'mailto:' + subtitle"
        [label]="subtitle"
        [disabled]="disabled"
        [target]="'_self'"
        [size]="Sizes.SMALL"
        [color]="Colors.BLACK"
      ></hdi-link>
    </ng-template>
    <hdi-link
      *ngIf="link"
      [type]="linkType"
      [href]="link"
      [label]="textLink | capitalize"
      [disabled]="disabled"
      [target]="linkTarget || '_self'"
      [size]="Sizes.SMALL"
      [color]="Colors.BLACK"
    ></hdi-link>
    <span class="date" [innerHTML]="date" *ngIf="date"></span>
  </div>
</div>

<div class="footer__card" *ngIf="type === 'footer'">
  <h6 *ngIf="title">{{ title }}</h6>
  <p [innerHTML]="subtitle" *ngIf="subtitle"></p>
  <strong [innerHTML]="strongText" *ngIf="strongText"></strong>
  <ng-container *ngIf="btnLabel && btnLabel.length">
    <hdi-button
      *ngIf="btnHref"
      [label]="btnLabel | capitalize"
      [type]="btnType"
      [href]="btnHref"
      [hrefType]="btnHrefType ? btnHrefType : HrefType.ANGULAR_ROUTE"
      [outlineColor]="btnColor"
      [linkRel]="linkRel"
      [linkTitle]="linkTitle"
    ></hdi-button>
  </ng-container>
</div>
